module.exports = __webpack_public_path__ + "media/images/new_landing/people/alina-vylchak-5b2de0cf9d3cac58a1352bbbb8e81348.jpeg";